export default __webpack_public_path__ + "static/media/spid-ico-circle-bb.9abc7ee7.svg";